/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { AvailabilityTypes } from 'sarsaparilla';

function AvailablilityLegend() {
    return (
        <AvailabilityTypes
            legendItems={{
                available: false,
                availableNumber: true,
                walkup: false,
                lottery: false,
                unavailable: true,
            }}
        />
    );
}

export default AvailablilityLegend;
